module.exports = {
      id: "comm-gadgets-usage",
      viewBox: "0 0 320 56.865",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#comm-gadgets",
      toString: function () {
        return this.url;
      }
    }